import { ReactNode } from "react";
import styles from "./FullPage.module.css";

function FullPage({ children }: { children: ReactNode }) {
  return <div className={styles.fullPage}>{children}</div>;
}

export default FullPage;
